// src/index.tsx

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "mobx-react";
import { createGlobalStyle } from "styled-components";
import App from "./App";
import { RootStore } from "./models/RootStore";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import { signInWithRedirect } from "aws-amplify/auth";
import { ConfigureApp } from "@blings/shared-auth-component";
import { getEnv } from "./utils/getEnv";

const awsmobile_changed: typeof awsExports = JSON.parse(
  JSON.stringify(awsExports)
);

const blingsApi = awsmobile_changed.aws_cloud_logic_custom.find(
  (api) => api.name === "BlingsAPI"
) as (typeof awsExports)["aws_cloud_logic_custom"][number] & {
  custom_headers?: () => Promise<Record<string, string>>;
};
blingsApi.endpoint = `https://${getEnv() === "dev" ? "dev." : ""}api.blings.io`;

blingsApi.custom_headers = async () => {
  return {
    "Access-Control-Allow-Credentials": "true",
    "Content-Type": "application/json",
  };
};
awsmobile_changed.aws_appsync_graphqlEndpoint = `https://${
  getEnv() === "dev" ? "dev." : ""
}graphql.blings.io/graphql`;

const isLocal = window.location.hostname.includes("localhost");
ConfigureApp(
  awsmobile_changed,
  Amplify,
  signInWithRedirect,
  isLocal
    ? "http://localhost:3000"
    : getEnv() === "dev"
    ? "https://dev.create.blings.io"
    : "https://create.blings.io"
);

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
  }
`;

const rootStore = RootStore.create({});

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <GlobalStyle />
    <Provider value={rootStore}>
      <App />
    </Provider>
  </React.StrictMode>
);
